import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import BuyNowPayLaterDetails from 'dpl/puppy_page/components/BuyNowPayLaterDetails';

export default function KlarnaDescription({ className, as: Component }) {
  return (
    <Component className={classnames('KlarnaDescription', className)}>
      Pay over time with Klarna.{' '}
      <BuyNowPayLaterDetails className="stone-700" buttonCTA="Learn more" />
    </Component>
  );
}

KlarnaDescription.propTypes = {
  className: PropTypes.string,
  as: PropTypes.string
};

KlarnaDescription.defaultProps = {
  className: null,
  as: 'p'
};
